import React, { useState, useContext ,useRef} from "react";
import { GlobalContext } from "../../context/provider";
import Barcode from 'react-barcode';
import './barcodeprint.css'
import getitemaction from "../../context/action/barcode/getitemaction";
import { Print_barcode_page } from "./print_barcode_page";
import { useReactToPrint } from "react-to-print";

const Barcodee = () => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);
    
    const [barcode,setbarcode]=useState();
    const [name,setname]=useState();
    const [price,setprice]=useState();
    const [code,setcode]=useState();

    const [error,seterror]=useState(false);
    const [error1,seterror1]=useState(false);

    const printRef = useRef();
        
    const printFn = useReactToPrint({
      contentRef: printRef,
      documentTitle: "item_code",
      preserveAfterPrint: true,
      print: (printIframe) =>
      new Promise(() => {
          printIframe.style.display = "none";
          printIframe.contentWindow?.print();
      }),
    });
  return (
    <>
    <div
        style={{
        position: 'absolute',
        left: '-99999px',
        top: 0
        }}
    >
        <Print_barcode_page ref={printRef} code={code} name={name} price={price} />
    </div>
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">لەیبڵ پرینتەر</h1>
          <p className="text-sm text-slate-400 mt-0.5">پرینت کردنی لەیبڵەکان</p>
        </div>
      </div>
        {/* Add New Expense Form */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
          <div className="w-full">
            <label
              className={
                error1
                  ? "block text-sm font-medium text-red-500 mb-1 text-right"
                  : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }
              for="item_code"
            >
              کۆد
            </label>
            <input
              className={
                error1
                  ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                  : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              id="item_code"
              type="text"
              placeholder=""
              value={barcode}
              onClick={(val)=>{val.target.select()}}
              onChange={(val) => setbarcode(val.target.value)}
              onFocus={() => seterror1(false)}
              onKeyDown={(key) => {
                if (key.key == "Enter") {
                  getitemaction(barcode)(setname)(setprice)(setcode)(clear);
                }
              }}
            />
          </div>
          <div className="w-full">
            <label
              className={
                "block text-sm font-medium text-slate-500 mb-1 text-right"
              }
              for="item_name"
            >
              ناوی کاڵا
            </label>
            <input
              className={
                "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-gray-200"
              }
              id="item_name"
              type="text"
              placeholder=""
              value={name}
              disabled={true}
              onChange={(val) => setname(val.target.value)}
            />
          </div>
          <div className="w-full">
            <label
              className={
                "block text-sm font-medium text-slate-500 mb-1 text-right"
              }
              for="item_price"
            >
              نرخ
            </label>
            <input
              className={
                "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-gray-200"
              }
              id="item_price"
              type="text"
              placeholder=""
              value={price}
              disabled={true}
              onChange={(val) => setprice(val.target.value)}
            />
          </div>
          <div className="w-full">
            <button
              className="h-10 px-6 bg-zinc-700 hover:bg-zinc-900 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
              onClick={() => {
                  if (barcode == "" || !barcode) {
                      seterror1(true);
                      return false;
                    }
                    printFn();
              }}
            >
              پرینت
            </button>
          </div>
        </div>
        </div>
        <div className="barcode_show">
          {/* <div className="w-full h-full flex flex-wrap justify-center items-stretch"> */}
          <div className="w-full px-3 flex justify-center text-sm">
            {code}
          </div>
          <div className="w-full flex justify-center text-sm">
            {name}
          </div>
          <div className="w-full flex justify-center ">
            {price} $
          </div>
        </div>
    </div>
    </>
  )
}

export default Barcodee